const styles = (theme) => ({
  fieldGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: theme.spacing.unit * 2,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  personalDetails: {
    color: theme.palette.custom.contacts,
    borderColor: theme.palette.border.lighter,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '100px',
  },
  emergencyContacts: {
    color: theme.palette.custom.contacts,
    borderColor: theme.palette.border.lighter,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '100px',
  },
  title: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    fontSize: '1.125rem',
  },
  helpText: {
    marginBottom: theme.spacing.unit * 2,
  },
  iconFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingBottom: '20px',
    paddingTop: '20px',
    position: 'relative',
    borderTop: `1px solid ${theme.palette.border.light}`,
    flexGrow: 1,
    '&:last-child': {
      paddingBottom: 0,
    },
    '&:first-child': {
      borderTop: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing.unit * 2,
      flexDirection: 'row',
    },
  },
  iconLabelWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  detailsWrapper: {
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 64px)',
    },
  },
  label: {
    color: theme.palette.text.dark,
    fontWeight: 600,
    fontFamily: 'Calibre',
    lineHeight: '1rem',
    marginBottom: 5,
    fontSize: '1rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      marginTop: -4,
      marginBottom: 1,
    },
  },
  labelDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100% - 210px)',
      display: 'block',
    },
  },
  labelMobile: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  value: {
    fontSize: '1.125rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.375rem',
    },
  },
  smValue: {
    fontSize: '1.375rem',
  },
  xsValue: {
    fontSize: '1.1875rem',
    whiteSpace: `pre-wrap`,
  },
  icon: {
    background: theme.palette.background.lighter,
    padding: theme.spacing.unit,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    marginRight: theme.spacing.unit * 1.5,
    width: 40,
    height: 40,
    color: theme.palette.custom.consented,
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing.unit * 2.5,
    },
  },
  actions: {
    minWidth: '150px',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: theme.spacing.unit * 2,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
      marginTop: -theme.spacing.unit * 1.5,
      paddingTop: 0,
    },
  },
  content: {
    display: 'inline-flex',
    flexGrow: 1,
  },
  contentRow: {
    flexDirection: 'column',
    marginTop: theme.spacing.unit,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginTop: 0,
    },
  },
  line: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  updating: {
    color: theme.palette.primary.dark,
    fontSize: '1.0625',
    fontWeight: 500,
    paddingRight: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
  },
  actionContainer: {
    borderTop: `1px solid ${theme.palette.border.light}`,
    marginTop: theme.spacing.unit,
    paddingTop: theme.spacing.unit * 0.5,
  },
});

export default styles;
